export default {
  props: {
    index: Number,
    id: String,
    title: String,
    text: String,
    image: {String, default: ''},
    date: String,
    link: { type: String },
    video: { type: String },
    linkTo: { type: String },
    linkText: { type: String, default: 'Подробнее' },
    clickable: { type: Boolean, default: true  },
  },

  computed: {
    // if you need to format date, change code here
    dateStr() {
      return this.date ? this.date : '';
    },
    // abstract method to overload
    linkUrl() {
      return '#';
    },
  },
  methods: {
    onLinkClick() {
      this.$emit('click', this.id);
    },
  },

  mounted() {
    if(this.sizeImgError && process.client)  {
      const image = new Image();
     // console.log('ert',this.image)
      image.src = this.image;
      // 540x540
      image.onerror = e => {
        this.isImages = `/images/${this.sizeImgError}.png`;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./components/shared/mixins/NewItemMixin.js